const MOEDA_TO_LOCALE: Record<string, string> = {
  BRL: 'pt-BR',
  USD: 'en-US',
  EUR: 'de-DE',
  GBP: 'en-GB',
  JPY: 'ja-JP',
};

export const formatPreco = (
  preco: number | null,
  moedaSigla: string | null,
): string => {
  if (preco == null) return '—';
  const sigla = moedaSigla ?? 'BRL';
  const locale = MOEDA_TO_LOCALE[sigla] ?? 'pt-BR';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: sigla,
    }).format(preco);
  } catch {
    return `${sigla} ${preco.toFixed(2)}`;
  }
};

export const formatDateTime = (iso: string | null): string => {
  if (!iso) return '—';
  try {
    const date = new Date(iso);
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch {
    return iso;
  }
};

export const formatDate = (iso: string | null): string => {
  if (!iso) return '—';
  try {
    const date = new Date(iso);
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  } catch {
    return iso;
  }
};

export const simNao = (value: boolean | null | undefined): string => {
  if (value == null) return '—';
  return value ? 'Sim' : 'Não';
};
